import React from 'react'
import PropTypes from 'prop-types'
import { Form, Icon, Input, Button, Select, Typography, DatePicker, Modal, Col, Row, Statistic } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment';
import logo from '../../../../assets/images/vtrc-logo.png'
import { Mutations } from '../../../../graphql'
import { message } from 'antd'
import { setToken, isLoggedIn, getLsId, checkLinkURL } from '../../../../utils/auth'
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";
import { UniqueFieldDefinitionNamesRule } from 'graphql';
import iconsLine from '../../../../assets/images/icons/line-news.png'
import OtpInput from 'react-otp-input';

const { Option } = Select;
const { Text, Title } = Typography
const { Countdown } = Statistic;

const { RangePicker } = DatePicker
const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
};
const nowyear = new Date().getFullYear() + 543 - 10;

const optionsmonth = [
	{ value: "1", name: 'มกราคม' },
	{ value: "2", name: 'กุมภาพันธ์' },
	{ value: "3", name: 'มีนาคม' },
	{ value: "4", name: 'เมษายน' },
	{ value: "5", name: 'พฤษภาคม' },
	{ value: "6", name: 'มิถุนายน' },
	{ value: "7", name: 'กรกฎาคม' },
	{ value: "8", name: 'สิงหาคม' },
	{ value: "9", name: 'กันยายน' },
	{ value: "10", name: 'ตุลาคม' },
	{ value: "11", name: 'พฤศจิกายน' },
	{ value: "12", name: 'ธันวาคม' },
];

let optionsyear = [];

class ConfirmUser extends React.PureComponent {
	state = {
		
	}

	handleSubmit = async e => {
		const { form } = this.props

      this.props.switchShowPage(4, this.props.otpToSead)
	}
	render() {
		const { form, otpToSead } = this.props

		return (
         <>
            <Form>
               <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 20 }}>
                  <img src={logo} alt="logo" className="logo-formlogin"  />
               </div>
               <div style={{ textAlign: 'center', marginTop: 10, marginBottom: 10 }}>
                  <Title level={3} style={{ marginBottom: '0' }}>รหัสกาชาดไอดีสำหรับการใช้งานของท่าน</Title>
				      <span style={{ color:"red" }}>กรุณาจดจำเพื่อใช้ Login ระบบต่างๆที่เชื่อมต่อกับระบบกาชาด</span>
                  {/* <b type="secondary">ยืนยันตัวตนของคุณ</b> */}
               </div>
			   	<Row gutter={16} type="flex" justify="left" align="top" className="py-4">
                  <Col md={24} className="my-5" align="center">
                     <Title level={4} style={{ marginBottom: '0' }}>
                        { this.props.dataProfileSSO.ssoId }
                     </Title>
                  </Col>
                  <Col md={24} className="mb-4" align="center">
                     <Button className='mr-md-1' type="primary btn-color-transparent btn-custom btn-cutom-width mb-2" htmlType="submit" onClick={this.handleSubmit} >
                           รับทราบ
                     </Button>
                     </Col>
               </Row>
            </Form>

            {/* <table>
               <tr>
                  <td>
                     <div className="ml-1">
                        <Icon type="file-text" />
                     </div>
                  </td>
                  <td style={{ verticalAlign:"top" }} className="pl-3">
                     <p className="mb-1 pt-1">
                        คำถามเกี่ยวกับรหัสบุคลากร
                     </p>
                  </td>
               </tr>
               <tr>
                  <td style={{ verticalAlign:"top" }}>
                     <div className="ml-1">
                        <Icon type="phone" rotate={90} />
                     </div>
                  </td>
                  <td style={{ verticalAlign:"top" }} className="pl-3">
                     <a style={{ color:"#595959" }} href="mailto:callcenter@vtrcsupport.com">
                     หากมีข้อสงสัย/แจ้งปัญหาการใช้งานสามารถติดต่อ<br></br>
                     ได้ที่ Callcenter@vtrcsupport.com
                     </a>
                  </td>
               </tr>
               <tr>
                  <td style={{ verticalAlign:"top" }}>
                     <div>
                        <img src={iconsLine} style={{ maxWidth: '24px', height: 'auto' }} />
                     </div>
                  </td>
                  <td style={{ verticalAlign:"top" }} className="pl-3">
                     <p className="mb-1 pt-1">
                        คำถามเกี่ยวกับรหัสบุคลากร
                     </p>
                  </td>
               </tr>
            </table> */}
         </>
		)
	}
}

ConfirmUser.defaultProps = {
	autoFocus: false
}

ConfirmUser.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedConfirmUser = Form.create()(ConfirmUser)

export default WrappedConfirmUser
